import styles from './search-layout.module.scss';
import { type CSSProperties, type ReactNode, useState } from 'react';
import Button from 'components/controls/buttons/button';
import CloseIcon from 'assets/icons/close-x.svg';
import FiltersIcon from 'assets/icons/filters.svg';
const OldSearchLayout = ({
	main,
	aside,
	children,
	inverted = false,
	fixedAside = false,
}: IProps) => {
	const [filtersOpen, setFiltersOpen] = useState(false);

	let classString = styles.contentSplit;
	classString = inverted ? `${classString} ${styles.inverted}` : classString;
	classString = fixedAside
		? `${classString} ${styles.fixedAside}`
		: classString;

	const componentStyles = {
		'--spacing-vertical': 0,
		'--spacing-horizontal': 0,
	} as CSSProperties;

	const asideClassString = filtersOpen
		? `${styles.aside} ${styles.open}`
		: styles.aside;

	const handleOpenFilter = () => setFiltersOpen(true);
	const handleCloseFilter = () => setFiltersOpen(false);

	return (
		<div>
			<section className={classString} style={componentStyles}>
				<div className={styles.main}>{main || children?.[0]}</div>
				<aside className={asideClassString}>
					<div className={styles.asideStickyContainer}>
						{filtersOpen && (
							<button
								className={styles.closeButton}
								onClick={handleCloseFilter}
							>
								Close <CloseIcon />
							</button>
						)}
						{aside || children?.[1]}
					</div>
				</aside>
			</section>
			{!filtersOpen && (
				<div className={styles.buttonWrapper}>
					<Button
						className={styles.filtersButton}
						appearance="secondary"
						onClick={handleOpenFilter}
					>
						Filter <FiltersIcon />
					</Button>
				</div>
			)}
		</div>
	);
};

export interface IProps {
	aside?: ReactNode;
	children?: ReactNode;
	// hold the filter rail at the same fixed width the collection search page uses,
	// instead of letting it grow with the window
	fixedAside?: boolean;
	inverted?: boolean;
	main?: ReactNode;
}

export default OldSearchLayout;
